// Libraries
import { Icon, IconProps } from '@chakra-ui/react';

/**
 * Component that renders the Rating Icon.
 * @param {IconProps} props - The IconProps for the RatingIcon component.
 * @returns {ReactElement} The RatingIcon component.
 */

// TODO: Rename this component to RatingMenuIcon.
export const RatingIcon = (props: IconProps) => {
  const { color = '#25CAD2', ...rest } = props;
  return (
    <Icon width='15' height='15' viewBox='0 0 15 15' color={color} fill='transparent' {...rest} id='rating'>
      <rect x='0.5' y='0.5' width='14' height='14' rx='2.5' stroke='currentColor' />
      <path
        d='M8.97 9.67H6.19L5.73 11H4.26L6.77 4.01H8.4L10.91 11H9.43L8.97 9.67ZM8.59 8.55L7.58 5.63L6.57 8.55H8.59Z'
        fill='currentColor'
      />
    </Icon>
  );
};
